import { master, songByKey, songKey } from "../data";
import type { SelectionMap, Song } from "../types";

const STORAGE_KEY = "wmlsti.selection.v1";

export function loadSelections(): SelectionMap {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}") as SelectionMap;
    return Object.fromEntries(
      Object.entries(parsed).filter(([album, selectedSong]) => songByKey.has(songKey(album, selectedSong))),
    );
  } catch {
    return {};
  }
}

export function saveSelections(selections: SelectionMap) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
}

export function clearSelections() {
  localStorage.removeItem(STORAGE_KEY);
}

export function selectedSongs(selections: SelectionMap): Song[] {
  return master.completed_albums.flatMap((album) => {
    const selected = selections[album];
    const song = selected ? songByKey.get(songKey(album, selected)) : undefined;
    return song ? [song] : [];
  });
}

export function isSelectionComplete(selections: SelectionMap) {
  return selectedSongs(selections).length === master.completed_albums.length;
}
